export default "__VITE_ASSET__DlbfLcKn__"